/* eslint-disable react/prop-types */
import React, { useState, useCallback } from 'react';
import { IconButton, Tooltip, Popover } from '@mui/material';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import PropTypes from 'prop-types';

import ColorPicker from './ColorPicker';

const ColorGroup = ({ cellFormat, onFormatChange }) => {
  const [textColorAnchor, setTextColorAnchor] = useState(null);
  const [bgColorAnchor, setBgColorAnchor] = useState(null);

  const handleTextColorClick = useCallback(
    (event) => {
      setTextColorAnchor(event.currentTarget);
    },
    [setTextColorAnchor]
  );

  const handleBgColorClick = useCallback(
    (event) => {
      setBgColorAnchor(event.currentTarget);
    },
    [setBgColorAnchor]
  );

  const handleTextColorClose = useCallback(() => {
    setTextColorAnchor(null);
  }, [setTextColorAnchor]);

  const handleBgColorClose = useCallback(() => {
    setBgColorAnchor(null);
  }, [setBgColorAnchor]);

  const handleTextColorSelect = useCallback(
    (color) => {
      onFormatChange('textColor', color);
      setTextColorAnchor(null);
    },
    [onFormatChange, setTextColorAnchor]
  );

  const handleBgColorSelect = useCallback(
    (color) => {
      onFormatChange('backgroundColor', color);
      setBgColorAnchor(null);
    },
    [onFormatChange, setBgColorAnchor]
  );

  return (
    <>
      <Tooltip title="Text Color">
        <IconButton
          size="small"
          onClick={handleTextColorClick}
          sx={{
            '& .MuiSvgIcon-root': {
              borderBottom: cellFormat?.color
                ? `3px solid ${cellFormat.color}`
                : 'none',
            },
          }}
        >
          <FormatColorTextIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Fill Color">
        <IconButton
          size="small"
          onClick={handleBgColorClick}
          sx={{
            '& .MuiSvgIcon-root': {
              borderBottom: cellFormat?.backgroundColor
                ? `3px solid ${cellFormat.backgroundColor}`
                : 'none',
            },
          }}
        >
          <FormatColorFillIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Popover
        open={Boolean(textColorAnchor)}
        anchorEl={textColorAnchor}
        onClose={handleTextColorClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        disableAutoFocus
      >
        <ColorPicker
          color={cellFormat?.color}
          onColorSelect={handleTextColorSelect}
        />
      </Popover>

      <Popover
        open={Boolean(bgColorAnchor)}
        anchorEl={bgColorAnchor}
        onClose={handleBgColorClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        disableAutoFocus
      >
        <ColorPicker
          color={cellFormat?.backgroundColor}
          onColorSelect={handleBgColorSelect}
        />
      </Popover>
    </>
  );
};

ColorGroup.propTypes = {
  cellFormat: PropTypes.shape({
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
  }).isRequired,
  onFormatChange: PropTypes.func.isRequired,
};

export default ColorGroup;
